import './loader.css';

import { cva,VariantProps } from 'class-variance-authority';

const loaderVariants = cva('', {
    variants: {
        variant: {
            default: 'scoped-default-loader',
            secondary: 'scoped-secondary-loader',
            destructive: 'scoped-destructive-loader',
            outline: 'scoped-outline-loader',
        },
        size: {
            sm: 'scoped-small-loader',
            lg: 'scoped-large-loader',
            xs: 'scoped-extra-small-loader'
        }
    },
    defaultVariants: {
        variant: 'default',
        size: 'sm'
    },
});

export interface LoaderProps
    extends React.HTMLAttributes<HTMLSpanElement>,
        VariantProps<typeof loaderVariants> {
    loading?: boolean;
}

const Loader = ({ className, variant, size }: LoaderProps) => {
    return (
        <span className={loaderVariants({ variant, className, size })}>
            <svg
                width="100%"
                height="100%"
                className="scoped-loader"
                viewBox="0 0 100 100"
                xmlns="http://www.w3.org/2000/svg"
            >
                <circle cx="50" cy="50" r="45" />
            </svg>
        </span>
    );
};

Loader.displayName = 'Loader';

export { Loader };
